import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import theme from '~/theme';

interface UnknownAccountProps {
  style?: React.CSSProperties;
}

const UnknownAccount: FC<UnknownAccountProps> = (props) => {
  const { style } = props;
  const { t } = useTranslation('terminals');
  return (
    <div
      style={{
        textDecoration: 'line-through',
        color: theme.errorColor,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        ...style,
      }}
    >
      {t('unknownAccount')}
    </div>
  );
};

export default UnknownAccount;
